/*global google, OverlappingMarkerSpiderfier, acalltracker*/
import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import queryString from "query-string";

import MarkerClusterer from "@google/markerclusterer";

import FiltersHolder from "../components/FiltersHolder";

import config, { styleSets } from "../../../js/config/mapconfig";

// const googleMapsKey = ''; // LOCAL TEST
const googleMapsKey = "AIzaSyD-zJnv8GB5ZKc77zsOBgdMF8nRlqo6ru8  ";

function EstablishmentOverview(props) {
    const {
        feedBaseUrl,
        tags,
        country,
        locale,
        origin,
        defaultBrand,
        defaultService,
        mapsLoaded,
        setMapsLoaded,
        baseName,
        pageTitle,
        siteTitle,
        metaTitle,
        metaDescription,
        socialDescription,
        metaImage,
        isFirstLocation,
    } = props;

    const [isPalm, setIsPalm] = useState(false);

    const [loadingScript, setLoadingScript] = useState(false);
    const [filtersReady, setFiltersReady] = useState(false);
    const [googleMap, setGoogleMap] = useState();
    const [mapStyle, setMapStyle] = useState();
    const [markerIcons, setMarkerIcons] = useState();
    const [markers, setMarkers] = useState();
    const [activeMarker, setActiveMarker] = useState();
    const [infoWindow, setInfoWindow] = useState();
    const [latLngBounds, setLatLngBounds] = useState();

    const [markerClusterer, setMarkerClusterer] = useState();
    const [overlappingMarkerSpiderfier, setOverlappingMarkerSpiderfier] =
        useState();

    const [findPlaceFromQueryError, setFindPlaceFromQueryError] = useState();

    const [brandOptions, setBrandOptions] = useState([]);
    const [serviceOptions, setServiceOptions] = useState([]);
    const [brand, setBrand] = useState({ value: defaultBrand });
    const [service, setService] = useState({ value: defaultService });
    const [locationQuery, setLocationQuery] = useState();
    const [establishments, setEstablishments] = useState();
    const [filteredEstablishments, setFilteredEstablishments] = useState();

    // DEBUG
    const [amountMapLoads, setAmountMapLoads] = useState(0);
    const [amountPlacesRequest, setAmountPlacesRequest] = useState(0);
    const [amountDistanceRequest, setAmountDistanceRequest] = useState(0);

    const mapElem = useRef(null);
    const placesElem = useRef(null);

    const queryParams = queryString.parse(window.location.search.substr(1), {
        arrayFormat: "comma",
    });

    // LOADING SCRIPT
    if (!mapsLoaded && !loadingScript) {
        setLoadingScript(true);

        // Create the script tag, set the appropriate attributes
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsKey}&libraries=geometry,places`;
        script.defer = true;

        script.onload = () => {
            setMapsLoaded(true);
            setLoadingScript(false);
        };

        // Append the 'script' element to 'head'
        document.head.appendChild(script);
    }

    const [shouldTriggerPageViewEvent, SetShouldTriggerPageViewEvent] =
        useState(false);
    useEffect(() => {
        if (!isFirstLocation) SetShouldTriggerPageViewEvent(true);
    }, []);

    // DEFAULTS
    useEffect(() => {
        setIsPalm(window.innerWidth < 768);

        window.addEventListener("resize", () => {
            setIsPalm(window.innerWidth < 768);
        });
    }, []);

    // GET DATA FROM FEED
    function getType(data) {
        let allType = [];
        for (let i = 0; i < data.length; i++) {
            allType = allType.concat(data[i].type);
        }
        const uniqueType = allType.filter(
            (item, i, ar) => ar.indexOf(item) === i
        );

        // if (country !== 'be') {
        //     const index = uniqueType.indexOf('Premium Service');
        //     if (index > -1) {
        //         uniqueType.splice(index, 1);
        //     }
        // }

        setServiceOptions(uniqueType);
    }

    // GET DATA TO BUILD FILTERS
    useEffect(() => {
        // let feed = `${feedBaseUrl}/api/v1/establishment/brands?limit=500&l=${locale}`;
        let feed = `${feedBaseUrl}`;
        // if (tags) {
        //     feed += `&tags=${tags}`;
        // }

        fetch(feed)
            .then((response) => response.json())
            .then((data) => {
                setBrandOptions(data.result);
            });
    }, [feedBaseUrl, locale, tags]);

    // GET ESTABLISHMENTS BASED ON SELECTED BRAND
    useEffect(() => {
        if (!feedBaseUrl || !filtersReady) return;

        // let url = `${feedBaseUrl}/api/v1/establishment/?limit=500&l=${locale}`;
        let url = `${feedBaseUrl}`;

        // if (tags) {
        //     url += `&tags=${tags}`;
        // }

        // if (brand.value) {
        //     url += `&brands[]=${brand.value}`;
        // }

        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                setEstablishments(data.result);
                getType(data.result);
            });
    }, [feedBaseUrl, filtersReady, tags, locale, brand]);

    // FILTER ESTABLISHMENTS
    function sortEstablishmentsOnDistance(a, b) {
        const distanceA = parseFloat(a.distance);
        const distanceB = parseFloat(b.distance);

        let comparison = 0;
        if (distanceA > distanceB) {
            comparison = 1;
        } else if (distanceA < distanceB) {
            comparison = -1;
        }
        return comparison;
    }

    useEffect(() => {
        if (!establishments) return;
        if (!googleMap && !isPalm) return;
        if (!serviceOptions.length) return;
        if (service.value && !serviceOptions.includes(service.value)) return;

        function matchValue(item) {
            if (!service.value) {
                return item;
            }

            if (item.type.includes(service.value)) {
                return item;
            }
            return false;
        }

        const filtered = establishments.filter(matchValue);

        if (!locationQuery) {
            for (let i = 0; i < filtered.length; i++) {
                const establishment = filtered[i];
                establishment.distanceFrom = false;
                establishment.distance = false;
            }
            setFilteredEstablishments(filtered);
            setFindPlaceFromQueryError("");
        } else {
            const restrictionArray = [
                { lat: 59.76860879345376, lng: -18.524004114746074 },
                { lat: 59.76860879345376, lng: 29.55148111474611 },
                { lat: 43.17129344424226, lng: 29.55148111474611 },
                { lat: 43.17129344424226, lng: -18.524004114746074 },
            ];

            const request = {
                query: locationQuery + " west-europa",
                fields: ["geometry", "type"],
                language: "nl",
            };

            let placeService;

            if (isPalm) {
                placeService = new google.maps.places.PlacesService(
                    placesElem.current
                );
            } else {
                placeService = new google.maps.places.PlacesService(googleMap);
            }
            const restrictionBoundsPoly = new google.maps.Polygon({
                paths: restrictionArray,
            });

            placeService.findPlaceFromQuery(request, (results, status) => {
                setAmountPlacesRequest(amountPlacesRequest + 1);

                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    const inBounds =
                        !!google.maps.geometry.poly.containsLocation(
                            results[0].geometry.location,
                            restrictionBoundsPoly
                        );
                    if (inBounds) {
                        const distance =
                            google.maps.geometry.spherical
                                .computeDistanceBetween;

                        let amountOfCalls = 0;

                        for (let i = 0; i < filtered.length; i++) {
                            const establishment = filtered[i];
                            if (
                                establishment.location.lat &&
                                establishment.location.lng &&
                                establishment.distanceFrom !== locationQuery
                            ) {
                                establishment.distanceFrom = locationQuery;
                                establishment.distance = (
                                    distance(
                                        results[0].geometry.location,
                                        new google.maps.LatLng(
                                            establishment.location.lat,
                                            establishment.location.lng
                                        )
                                    ) / 1000
                                ).toFixed(1);
                                amountOfCalls += 1;
                            }
                        }

                        setAmountDistanceRequest(
                            amountDistanceRequest + amountOfCalls
                        );

                        if (googleMap) {
                            googleMap.setCenter(results[0].geometry.location);
                            switch (results[0].types[0]) {
                                case "country":
                                    googleMap.setZoom(8);
                                    break;
                                case "locality":
                                    googleMap.setZoom(12);
                                    break;
                                case "postal_code":
                                    googleMap.setZoom(12);
                                    break;
                                default:
                                    googleMap.setZoom(12);
                                    break;
                            }

                            /* Search center + first marker in bounds
                            if (!googleMap.getBounds().contains(new google.maps.LatLng(filtered[0].location.lat, filtered[0].location.lng))) {
                              const minBounds = new google.maps.LatLngBounds();
                              minBounds.extend(results[0].geometry.location);
                              minBounds.extend(new google.maps.LatLng(filtered[0].location.lat, filtered[0].location.lng));
                              googleMap.fitBounds(minBounds);
                            }
                            */
                        }

                        filtered.sort(sortEstablishmentsOnDistance);

                        if (googleMap) {
                            // Zoom to marker
                            let currentZoomlevel = googleMap.getZoom();
                            if (currentZoomlevel) {
                                while (true) {
                                    currentZoomlevel -= 1;
                                    googleMap.setZoom(currentZoomlevel);
                                    if (
                                        googleMap
                                            .getBounds()
                                            .contains(
                                                new google.maps.LatLng(
                                                    filtered[0].location.lat,
                                                    filtered[0].location.lng
                                                )
                                            )
                                    ) {
                                        break;
                                    }

                                    if (currentZoomlevel < 10) {
                                        break;
                                    }
                                }
                            }
                        }

                        filtered.sort(sortEstablishmentsOnDistance);
                        setFilteredEstablishments(filtered);

                        setFindPlaceFromQueryError("");
                    } else {
                        setFindPlaceFromQueryError(
                            "Deze plaats ligt buiten de beschikbare regio."
                        );
                    }
                } else {
                    setFindPlaceFromQueryError(
                        "Plaats niet gevonden of niet specifiek genoeg."
                    );
                }
            });
        }
    }, [googleMap, establishments, service, serviceOptions, locationQuery]);

    // INIT MAP
    function onMapZoomChanged(zoom) {
        if (zoom < 10) {
            setMapStyle("minimal");
        } else {
            setMapStyle("maximal");
        }
    }

    useEffect(() => {
        if (isPalm || !mapsLoaded || !mapElem.current) {
            return;
        }

        // central europe
        const restrictionBounds = {
            north: 59.76860879345376,
            south: 43.17129344424226,
            west: -18.524004114746074,
            east: 29.55148111474611,
        };

        // create map
        const googleMapItem = new google.maps.Map(
            mapElem.current,
            config("abstract", 7, { lat: 52.164792, lng: 5.651937 })
        );

        setAmountMapLoads(amountMapLoads + 1);

        // set restrictions
        googleMapItem.setRestriction({
            latLngBounds: restrictionBounds,
            strictBounds: false,
        });

        // create marker vars
        const markerIconPoint = {
            url: "/_resources/themes/schellevis/img/marker-pinpoint.svg",
            scaledSize: new google.maps.Size(24, 36), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(12, 12), // anchor
        };

        const markerIconPointActive = {
            url: "/_resources/themes/schellevis/img/marker-pinpoint-active.svg",
            scaledSize: new google.maps.Size(24, 36), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(12, 12), // anchor
        };

        const markerIconPointHighlight = {
            url: "/_resources/themes/schellevis/img/marker-pinpoint-highlight.svg",
            scaledSize: new google.maps.Size(24, 36), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(12, 12), // anchor
        };

        const markerIconPointPlus = {
            url: "/_resources/themes/schellevis/img/marker-pinpoint-plus.svg",
            scaledSize: new google.maps.Size(24, 36), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(12, 12), // anchor
        };

        // create map style vars
        const styleMapMinimal = new google.maps.StyledMapType(
            styleSets.abstract,
            { map: googleMapItem, name: "minimial" }
        );
        googleMapItem.mapTypes.set("minimal", styleMapMinimal);
        const styleMapMaximal = new google.maps.StyledMapType(
            styleSets.abstractAlt,
            { map: googleMapItem, name: "maximal" }
        );
        googleMapItem.mapTypes.set("maximal", styleMapMaximal);
        googleMapItem.setMapTypeId("minimal");

        // event listneners
        google.maps.event.addListener(googleMapItem, "zoom_changed", () => {
            onMapZoomChanged(googleMapItem.getZoom());
        });

        // set states
        setMarkerIcons({
            default: markerIconPoint,
            active: markerIconPointActive,
            highlight: markerIconPointHighlight,
            plus: markerIconPointPlus,
        });

        setGoogleMap(googleMapItem);
    }, [mapsLoaded, mapElem, isPalm]);

    // CREATE BOUNDS HOLDER
    useEffect(() => {
        if (!googleMap) {
            return;
        }
        const bounds = new google.maps.LatLngBounds();
        setLatLngBounds(bounds);
    }, [googleMap]);

    // CREATE INFO WINDOW HOLDER
    useEffect(() => {
        if (!googleMap) {
            return;
        }

        const infowindow = new window.google.maps.InfoWindow();
        google.maps.event.addListener(infowindow, "closeclick", () => {
            setActiveMarker(null);
        });
        setInfoWindow(infowindow);
    }, [googleMap]);

    // CREATE OVERLAPPING MARKER SPIDERFIER
    //   useEffect(() => {
    //     if (!googleMap) { return; }
    //     const oms = new OverlappingMarkerSpiderfier(googleMap, {
    //       markersWontMove: true,
    //       markersWontHide: true,
    //       keepSpiderfied: true,
    //       ignoreMapClick: false,
    //       basicFormatEvents: false,
    //     });

    //     googleMap.addListener('idle', () => {
    //       // h = formatMarkers in minified file
    //       Object.getPrototypeOf(oms).h.call(oms);
    //     });

    //     setOverlappingMarkerSpiderfier(oms);
    //   }, [googleMap]);

    // CREATE CLUSTER HOLDER
    useEffect(() => {
        if (!googleMap) {
            return;
        }
        const clusterer = new MarkerClusterer(googleMap, [], {
            averageCenter: true,
            imagePath: "/_resources/themes/schellevis/img/m",
            maxZoom: 15,
        });

        setMarkerClusterer(clusterer);
    }, [googleMap]);

    // SET MAP STYLE
    useEffect(() => {
        if (!googleMap || !mapStyle) {
            return;
        }
        googleMap.setMapTypeId(mapStyle);
    }, [mapStyle]);

    // SET MARKERS
    function jumpToMarker(marker) {
        googleMap.setCenter(marker.position);
        googleMap.setZoom(14);
    }

    function openMarker(establishment, marker = null, jump = false) {
        function getMarker(item) {
            return item.metadata.id === establishment.id;
        }

        if (marker === null) {
            // eslint-disable-next-line no-param-reassign
            marker = markers.find(getMarker);
        }

        let infoWindowContent = `
      <div class="infowindow">
        <div class="infowindow__inner">
          <div class="infowindow__title">${establishment.title}</div>
          <address class="infowindow__address">
            ${establishment.address.street} ${establishment.address.houseNumber}<br>
            ${establishment.address.postalCode} ${establishment.address.city}`;

        if (establishment.phoneNumberLink && establishment.phoneNumber) {
            infoWindowContent += `<br><a href="tel:${establishment.phoneNumberLink}" target="_blank">${establishment.phoneNumber}</a>`;
        }

        if (establishment.url) {
            infoWindowContent += `<br><a href="http://${establishment.url}" target="_blank">${establishment.url}</a>`;
        }

        if (establishment.email) {
            infoWindowContent += `<br><a href="mailto:${establishment.email}" target="_blank">${establishment.email}</a>`;
        }

        if (
            establishment.social.Linkedin ||
            establishment.social.Instagram ||
            establishment.social.Pinterest ||
            establishment.social.Facebook
        ) {
            infoWindowContent += `<br>`;
        }

        if (establishment.social.Linkedin) {
            infoWindowContent += `
            <a href="${establishment.social.Linkedin}" target="_blank" class="social-icon"><svg role="img" class="icon fill--base" alt="LinkedIn">
                <use href="/_resources/themes/schellevis/img/sprite.svg#linkedin" alt="LinkedIn"></use>
            </svg></a>`;
        }

        if (establishment.social.Instagram) {
            infoWindowContent += `
            <a href="${establishment.social.Instagram}" target="_blank" class="social-icon"><svg role="img" class="icon fill--base" alt="Instagram">
                <use href="/_resources/themes/schellevis/img/sprite.svg#instagram" alt="Instagram"></use>
            </svg></a>`;
        }

        if (establishment.social.Pinterest) {
            infoWindowContent += `
            <a href="${establishment.social.Pinterest}" target="_blank" class="social-icon"><svg role="img" class="icon fill--base" alt="Pinterest">
                <use href="/_resources/themes/schellevis/img/sprite.svg#pinterest" alt="Pinterest"></use>
            </svg></a>`;
        }

        if (establishment.social.Facebook) {
            infoWindowContent += `
            <a href="${establishment.social.Facebook}" target="_blank" class="social-icon"><svg role="img" class="icon fill--base" alt="Facebook">
                <use href="/_resources/themes/schellevis/img/sprite.svg#facebook-base" alt="Facebook"></use>
            </svg></a>`;
        }

        infoWindowContent += `</address></div></div>`;

        if (establishment.Detailpagina == "Ja") {
            infoWindowContent += `<a href="${establishment.link}" class="infowindow__button"></a>`;
        }

        infoWindowContent += `</div>`;

        infoWindow.setContent(infoWindowContent);

        // marker.setIcon(markerIcons.active);
        setActiveMarker(marker);
        infoWindow.open(googleMap, marker);

        if (jump) {
            jumpToMarker(marker);
        }
    }

    function clearAllMarkers() {
        if (!markers) {
            return;
        }

        for (let i = 0; i < markers.length; i++) {
            const marker = markers[i];
            marker.setMap(null);
        }

        const bounds = new google.maps.LatLngBounds();
        setLatLngBounds(bounds);
        markerClusterer.clearMarkers();
        // overlappingMarkerSpiderfier.forgetAllMarkers();
        setMarkers(null);
    }

    useEffect(() => {
        if (
            !googleMap ||
            !markerIcons ||
            !Array.isArray(filteredEstablishments) ||
            !filteredEstablishments.length ||
            !latLngBounds ||
            !infoWindow
        ) {
            return;
        }

        clearAllMarkers();

        const markersArr = [];

        for (let i = 0; i < filteredEstablishments.length; i++) {
            const establishment = filteredEstablishments[i];

            let location = false;

            if (establishment.location.lat && establishment.location.lng) {
                location = {
                    lat: parseFloat(establishment.location.lat),
                    lng: parseFloat(establishment.location.lng),
                };
            }

            if (location) {
                const marker = new google.maps.Marker({
                    map: googleMap,
                    position: location,
                    icon: markerIcons.default,
                });
                marker.metadata = { type: "point", id: establishment.id };
                markersArr.push(marker);
                latLngBounds.extend(location);

                google.maps.event.addListener(marker, "click", () => {
                    openMarker(establishment, marker);
                });

                // eslint-disable-next-line no-loop-func
                google.maps.event.addListener(marker, "spider_click", () => {
                    openMarker(establishment, marker);
                });

                // eslint-disable-next-line no-loop-func
                google.maps.event.addListener(
                    marker,
                    "spider_format",
                    (status) => {
                        let icon = null;

                        //   if (status === OverlappingMarkerSpiderfier.markerStatus.SPIDERFIED) {
                        //     icon = markerIcons.highlight;
                        //   } else if (status === OverlappingMarkerSpiderfier.markerStatus.SPIDERFIABLE) {
                        //     icon = markerIcons.plus;
                        //   } else {
                        icon = markerIcons.default;
                        //   }

                        if (icon) {
                            marker.setIcon(icon);
                        }
                    }
                );

                // overlappingMarkerSpiderfier.trackMarker(marker);
            }
        }

        setMarkers(markersArr);

        if (!locationQuery) {
            if (markersArr.length) {
                googleMap.fitBounds(latLngBounds, 50);
                googleMap.panToBounds(latLngBounds, 50);
            } else {
                googleMap.setCenter({ lat: 52.164792, lng: 5.651937 });
                googleMap.setZoom(8);
            }
        }

        markerClusterer.addMarkers(markersArr, true);

        if (typeof acalltracker !== "undefined") {
            acalltracker.dynamicContentload();
        }
    }, [googleMap, filteredEstablishments, markerIcons]);

    // SET ACTIVE MARKER
    useEffect(() => {
        if (!markers || !markerIcons) {
            return;
        }

        for (let i = 0; i < markers.length; i++) {
            const marker = markers[i];
            // marker.setIcon(markerIcons.default);
        }

        if (activeMarker) {
            // activeMarker.setIcon(markerIcons.active);
        }
    }, [activeMarker]);

    function onSearchMap(value) {
        setLocationQuery(value);
    }

    function setFilters(filteredBrand, filteredService) {
        setBrand(filteredBrand);
        setService(filteredService);

        if (!filtersReady) {
            setFiltersReady(true);
        }
    }

    const filterContent = (
        <FiltersHolder
            brands={brandOptions}
            defaultBrand={defaultBrand}
            type={serviceOptions}
            defaultService={defaultService}
            onSubmit={setFilters}
            onSearchMap={onSearchMap}
            findPlaceFromQueryError={findPlaceFromQueryError}
        />
    );

    let overviewContent = null;

    if (
        Array.isArray(filteredEstablishments) &&
        filteredEstablishments.length
    ) {
        overviewContent = (
            <div className="map-list">
                {filteredEstablishments.map((establishment) => (
                    <div className="map-list__item" key={establishment.id}>
                        <div className="map-list__item-content sign-s">
                            <div className="map-list__item-title">
                                {establishment.title}
                            </div>
                            <address>
                                {`${establishment.address.street} ${establishment.address.houseNumber}`}
                                <br />
                                {`${establishment.address.postalCode} ${establishment.address.city}`}
                                <br />
                                {establishment.adCallsTelLink &&
                                establishment.adCallsEAN &&
                                establishment.adCallsTelView ? (
                                    <a
                                        href={`tel:${establishment.adCallsTelLink}`}
                                        className="calltracker"
                                        data-aen={establishment.adCallsEAN}
                                    >
                                        {establishment.adCallsTelView}
                                    </a>
                                ) : (
                                    establishment.phoneNumberLink && (
                                        <a
                                            href={`tel:${establishment.phoneNumberLink}`}
                                        >
                                            {establishment.phoneNumber}
                                        </a>
                                    )
                                )}

                                <br />
                                {establishment.url && (
                                    <a
                                        href={`http://${establishment.url}`}
                                        target="_blank"
                                    >
                                        {establishment.url}
                                    </a>
                                )}
                                <br />
                                {establishment.email && (
                                    <a
                                        class="sign-s"
                                        href={`mailto:${establishment.email}`}
                                        target="_blank"
                                    >
                                        {establishment.email}
                                    </a>
                                )}

                                <div class="socials-dealerlocator">
                                    {establishment.social.Linkedin && (
                                        <a
                                            href={`${establishment.social.Linkedin}`}
                                            target="_blank"
                                        >
                                            <svg
                                                role="img"
                                                class="icon fill--base"
                                                alt="LinkedIn"
                                            >
                                                <use
                                                    href="/_resources/themes/schellevis/img/sprite.svg#linkedin"
                                                    alt="LinkedIn"
                                                ></use>
                                            </svg>
                                        </a>
                                    )}

                                    {establishment.social.Instagram && (
                                        <a
                                            href={`${establishment.social.Instagram}`}
                                            target="_blank"
                                        >
                                            <svg
                                                role="img"
                                                class="icon fill--base"
                                                alt="Instagram"
                                            >
                                                <use
                                                    href="/_resources/themes/schellevis/img/sprite.svg#instagram"
                                                    alt="LinkedIn"
                                                ></use>
                                            </svg>
                                        </a>
                                    )}

                                    {establishment.social.Pinterest && (
                                        <a
                                            href={`${establishment.social.Pinterest}`}
                                            target="_blank"
                                        >
                                            <svg
                                                role="img"
                                                class="icon fill--base"
                                                alt="Pinterest"
                                            >
                                                <use
                                                    href="/_resources/themes/schellevis/img/sprite.svg#pinterest"
                                                    alt="LinkedIn"
                                                ></use>
                                            </svg>
                                        </a>
                                    )}

                                    {establishment.social.Facebook && (
                                        <a
                                            href={`${establishment.social.Facebook}`}
                                            target="_blank"
                                        >
                                            <svg
                                                role="img"
                                                class="icon fill--base"
                                                alt="Facebook"
                                            >
                                                <use
                                                    href="/_resources/themes/schellevis/img/sprite.svg#facebook-base"
                                                    alt="LinkedIn"
                                                ></use>
                                            </svg>
                                        </a>
                                    )}
                                </div>

                                {establishment.distance && (
                                    <div className="map-list__item-distance">
                                        {`${
                                            establishment.distance
                                        } KM (${ss.i18n._t(
                                            "EstablishmentApp.DISTANCE_FROM"
                                        )} ${establishment.distanceFrom})`}
                                    </div>
                                )}
                            </address>
                        </div>

                        <div className="map-list__item-actions">
                            {establishment.Detailpagina == "Ja" && (
                                <a
                                    href={`${establishment.link}`}
                                    className="cta--arrow hidden--palm"
                                >
                                    {establishment.buttonText}
                                </a>
                            )}

                            {establishment.Detailpagina == "Nee" && (
                                <a
                                    onClick={() =>
                                        openMarker(establishment, null, true)
                                    }
                                    className="cta--arrow hidden--palm"
                                >
                                    {establishment.buttonText}
                                </a>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        );
    } else if (
        Array.isArray(filteredEstablishments) &&
        !filteredEstablishments.length
    ) {
        overviewContent = (
            <div className="island">
                {ss.i18n._t("EstablishmentApp.NO_RESULTS")}
            </div>
        );
    } else {
        overviewContent = (
            <div className="map-list">
                <div className="map-list__item">
                    <div className="map-list__item-content">
                        <div className="ghost-element-holder ghost-element-holder--lines">
                            <span
                                className="ghost-element ghost-element--line"
                                style={{ width: "180px" }}
                            />
                            <span
                                className="ghost-element ghost-element--line"
                                style={{ width: "160px" }}
                            />
                            <span
                                className="ghost-element ghost-element--line"
                                style={{ width: "150px" }}
                            />
                            <span
                                className="ghost-element ghost-element--line"
                                style={{ width: "175px" }}
                            />
                        </div>
                    </div>
                    <div className="map-list__item-actions">
                        <div
                            className="ghost-element ghost-element--button"
                            style={{ width: "176px" }}
                        />
                    </div>
                </div>
                <div className="map-list__item">
                    <div className="map-list__item-content">
                        <div className="ghost-element-holder ghost-element-holder--lines">
                            <span
                                className="ghost-element ghost-element--line"
                                style={{ width: "180px" }}
                            />
                            <span
                                className="ghost-element ghost-element--line"
                                style={{ width: "160px" }}
                            />
                            <span
                                className="ghost-element ghost-element--line"
                                style={{ width: "150px" }}
                            />
                            <span
                                className="ghost-element ghost-element--line"
                                style={{ width: "175px" }}
                            />
                        </div>
                    </div>
                    <div className="map-list__item-actions">
                        <div
                            className="ghost-element ghost-element--button"
                            style={{ width: "176px" }}
                        />
                    </div>
                </div>
                <div className="map-list__item">
                    <div className="map-list__item-content">
                        <div className="ghost-element-holder ghost-element-holder--lines">
                            <span
                                className="ghost-element ghost-element--line"
                                style={{ width: "180px" }}
                            />
                            <span
                                className="ghost-element ghost-element--line"
                                style={{ width: "160px" }}
                            />
                            <span
                                className="ghost-element ghost-element--line"
                                style={{ width: "150px" }}
                            />
                            <span
                                className="ghost-element ghost-element--line"
                                style={{ width: "175px" }}
                            />
                        </div>
                    </div>
                    <div className="map-list__item-actions">
                        <div
                            className="ghost-element ghost-element--button"
                            style={{ width: "176px" }}
                        />
                    </div>
                </div>
            </div>
        );
    }

    let content = null;

    content = (
        <section className="map">
            <div className="filter-container">
                <div className="site-width">{filterContent}</div>
            </div>

            <aside className="map__aside">
                <div ref={placesElem} />
                {overviewContent}
            </aside>
            <div ref={mapElem} className="map__main" />
        </section>
    );

    return (
        <div>
            {/* <Helmet>
                <title>{pageTitle}</title>
                <meta property="og:site_name" content={siteTitle} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={origin + baseName} />
                <meta property="og:title" content={metaTitle} />
                <meta name="description" content={metaDescription} />
                <meta property="og:description" content={socialDescription} />
                <meta property="og:image" content={metaImage} />

                {shouldTriggerPageViewEvent && (
                    <script>
                        {`
              window.dataLayer.push({
                'event': 'page_view',
                'page_name': '${pageTitle} | ${siteTitle}',
                'page_type': 'EstablishmentPage-index',
              });
            `}
                    </script>
                )}
            </Helmet> */}
            {content}
        </div>
    );
}

EstablishmentOverview.propTypes = {
    feedBaseUrl: PropTypes.string.isRequired,
    tags: PropTypes.string,
    country: PropTypes.string,
    locale: PropTypes.string,
    origin: PropTypes.string.isRequired,
    pageTitle: PropTypes.string.isRequired,
    metaTitle: PropTypes.string,
    metaDescription: PropTypes.string,
    socialDescription: PropTypes.string,
    metaImage: PropTypes.string.isRequired,
    siteTitle: PropTypes.string,
    defaultBrand: PropTypes.string,
    defaultService: PropTypes.string,
    mapsLoaded: PropTypes.bool.isRequired,
    setMapsLoaded: PropTypes.func.isRequired,
    isFirstLocation: PropTypes.bool,
};

EstablishmentOverview.defaultProps = {
    defaultBrand: "",
    defaultService: "",
    siteTitle: "Schellevis",
    metaTitle: "Dealer",
    metaDescription: "Dealer",
    socialDescription: "Dealer",
};

export default EstablishmentOverview;
